export default __webpack_public_path__ + "static/review-decorist-f5686b0b0a011edbeb771f72c0475272.webp";